'use client';
import { useIntercomSupport } from '@/hooks/useIntercomSupport';
import useAnalytics from '@/lib/analytics/useAnalytics';
import Logo from '../../../components/Logo';
import { ConnectWithUs } from './ConnectWithUs';

interface LinkSection {
  title: string;
  links: {
    label: string;
    href?: string;
    target?: '_blank';
    id?: string;
  }[];
}

const linkSections: LinkSection[] = [
  {
    title: 'Resources',
    links: [
      // {
      //   label: 'Blog',
      //   href: '/blog',
      //   target: '_blank',
      // },
      {
        label: 'User guide',
        href: '/guide',
        target: '_blank',
      },
      {
        label: 'Changelog',
        href: '/changelog',
      },
      {
        label: 'FAQs',
        href: '/faqs',
      },
      {
        label: 'Slack',
        href: 'https://join.slack.com/t/anaralabs/shared_invite/zt-31jynhzwy-htE9AD03A1Q~ySpLaEpiew',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Company',
    links: [
      {
        label: 'Careers',
        href: 'https://www.ycombinator.com/companies/anara/jobs/',
        target: '_blank',
      },
      {
        label: 'Support',
        id: 'intercom_support',
      },
      {
        label: 'Contact',
        href: 'mailto:support@anara.com',
      },
      // {
      //   label: 'Affiliates',
      //   href: 'https://unriddle.tolt.io/login',
      // },
      {
        label: 'Press Kit',
        href: '/press',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Product',
    links: [
      {
        label: 'Web app',
        href: '/new',
      },
      {
        label: 'Chrome app',
        href: '/chrome',
        target: '_blank',
      },
      {
        label: 'Lector viewer',
        href: '/lector',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Legal',
    links: [
      {
        label: 'Terms',
        href: '/terms',
        target: '_blank',
      },
      {
        label: 'Privacy',
        href: '/privacy',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Socials',
    links: [
      {
        label: 'X (Twitter)',
        href: 'https://twitter.com/anaralabs',
        target: '_blank',
      },
      {
        label: 'Instagram',
        href: 'https://www.instagram.com/anaralabs/',
        target: '_blank',
      },
      {
        label: 'TikTok',
        href: 'https://www.tiktok.com/@anaralabs',
        target: '_blank',
      },
      {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/company/anaralabs/',
        target: '_blank',
      },
    ],
  },
];

const Footer: React.FC = () => {
  const { track } = useAnalytics();
  useIntercomSupport();

  return (
    <>
      <ConnectWithUs />
      <div className="max-w-[1072px] w-full mx-auto px-6 pb-[60px] md:pb-28  flex text-base">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 justify-between items-start w-full">
          <div className="grid grid-flow-row-dense max-sm:grid-cols-3 grid-cols-5 gap-9 max-lg:mb-16 ">
            {linkSections.map((section) => (
              <div key={section.title}>
                <h3 className="text-black text-base leading-[18px] font-semibold mb-3">
                  {section.title}
                </h3>
                <ul>
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        id={link.id}
                        target={link.target}
                        onClick={() => {
                          track('footer_button_clicked', { link: link.label });
                          if (link.label === 'Slack Community') {
                            track('slack_community_clicked', {
                              onFooter: true,
                            });
                          }
                        }}
                        className="text-[#9A9A9A] font-semibold text-base leading-[18px] cursor-pointer transition-all ease duration-200 hover:text-black block mb-2.5"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="w-full sm:w-1/5 flex flex-col items-start gap-3 sm:mb-0">
            <Logo
              className="h-8"
              href="/"
              onClick={() => track('footer_button_clicked', { link: 'logo' })}
            />
            <p className="text-[#9A9A9A] text-base pb-5 leading-[16px] font-semibold">
              © 2025 Anara Labs, Inc
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
